module.exports = __webpack_public_path__ + "static/Apercu-Italic-4dfc0a66e23ca7d409f97d93dd95e512.woff2";